import React from 'react';
import { Field, reduxForm } from 'redux-form';

import Input from '../../modules/Input';
import Button from '../../modules/Button';
import InputGroup from '../../modules/InputGroup';
import FormButtonPanel from '../../modules/FormButtonPanel';
import AlertBox from '../../modules/AlertBox';

import styles from './styles.scss';
import AlertMessage from "../../modules/AlertMessage/index";
import FormatAlertMessage from "../../modules/FormatAlertMessage/index";

class ForgottenPassword extends React.Component {
    render() {

        const { handleSubmit, submitting, pristine, error } = this.props;

        return (
            <div>
                <AlertMessage>
                    {error && (
                        <AlertBox theme="danger">
                            <FormatAlertMessage
                                genericMessage={'There was a problem sending the password reset.'}
                                error={error}
                            />
                        </AlertBox>
                    )}
                </AlertMessage>

                <form onSubmit={ handleSubmit }>
                    <InputGroup>
                        <Field name="email" component={Input} type="email" required="true" label="Email" />
                    </InputGroup>

                    <FormButtonPanel position="bottom">
                        <Button type="submit" disabled={pristine || submitting}>Send reset email</Button>
                    </FormButtonPanel>
                </form>
            </div>
        )
    }
}

export default reduxForm({ form: 'forgotten-password' })(ForgottenPassword);